const CartlistItem = {
  init(target) {
    const modal = target.querySelector('.cartlist__modal')
    const modalContainer = modal?.querySelector('.container') as HTMLElement
    const closeBtn = modal?.querySelector('.modal__close')
    const btn = target.querySelector('.cartlist__editbtn')

    if (btn) {
      btn.addEventListener('click', () => this.open(modal))
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close(modal))
    }

    window.addEventListener('resize', () => this.resize(modalContainer))
    window.addEventListener('load', () => this.resize(modalContainer))
  },
  resize(modalContainer) {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const aspectRatio = 16 / 9

    if (windowHeight < windowWidth && modalContainer) {
      const preferredNewWidth = (windowHeight - 180) * aspectRatio
      const newContainerWidth = preferredNewWidth > windowWidth ? windowWidth : preferredNewWidth

      modalContainer.setAttribute('style', `width:${newContainerWidth}px`)
    } else if (modalContainer) {
      modalContainer.setAttribute('style', 'width:100%')
    }
  },
  open(modal) {
    modal.classList.add('modal--open')
  },
  close(modal) {
    modal.classList.remove('modal--open')
  },
}

export default CartlistItem
